<button type="button" [ngStyle]="buttonStyles">{{ innerText }}</button>

<ng-container *ipEmailBuilderSettings [ipEmailBuilderHistoryHost]="this | toHistoryOptions">
  <h2 tailH2 i18n="@@button_block_text">Button text</h2>
  <div tailPanel>
    <input type="text" tailInput [(ngModel)]="innerText">
  </div>
  <h2 tailH2 i18n="@@font">Font</h2>
  <div tailPanel>
    <tail-font [(value)]="options.font"></tail-font>
  </div>
  <h2 tailH2 i18n="@@button_color">Color</h2>
  <div tailPanel>
    <tail-color [(value)]="options.color" allowTransparent="false"></tail-color>
  </div>
  <h2 tailH2 i18n="@@button_block_background_color">Background color</h2>
  <div tailPanel>
    <tail-color [(value)]="options.backgroundColor"></tail-color>
  </div>
  <h2 tailH2 i18n="@@border">Border</h2>
  <div tailPanel>
    <tail-border [(value)]="options.border"></tail-border>
  </div>
  <h2 tailH2 i18n="@@button_block_attributes">Attributes</h2>
  <div tailPanel>
    <div class="grid grid-cols-3 gap-2">
      <tail-align [(value)]="options.align" class="col-span-2"></tail-align>
      <button tailBtn (click)="options.fullWidth = !options.fullWidth" [class.active]="options.fullWidth"
              i18n="@@button_block_full_width">
        Full Width
      </button>
    </div>
    <tail-link class="pt-2" [(value)]="options.link"></tail-link>
    <div class="flex flex-col pt-2">
      <h3 tailH3 i18n="@@button_block_inner_padding">Inner Padding</h3>
      <tail-padding [(value)]="options.innerPadding"></tail-padding>
    </div>
    <div class="flex flex-col pt-2">
      <h3 tailH3 i18n="@@padding">Padding</h3>
      <tail-padding [(value)]="options.padding"></tail-padding>
    </div>
  </div>
</ng-container>
